/* eslint-disable class-methods-use-this */
import SelectMulti from "components/SelectMulti/selectmulti.component";
import { LISTA_LINKS_AUDIENCIA } from "constants/index";
import { saveAs } from "file-saver";
import { Form, Formik } from "formik";
import moment from "moment";
import { LoadingStyle } from "pages/comum/Layout/layout.style";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Accordion } from "react-sanfona";
import AccordionItem from "react-sanfona/dist-modules/AccordionItem";
import { compareByNome } from "utils/orderHelper";
import UploadBrowseFile from "../../../components/BrowseFile/uploadRedux.component";
import Button from "../../../components/Button/button.component";
import WidgetDialog from "../../../components/Dialog/dialog.component";
import InputText from "../../../components/Input/inputText.component";
import Required from "../../../components/Required/required.component";
import Subtitle from "../../../components/Subtitle/subtitle.component";
import Table from "../../../components/Table/table.component";
import Title from "../../../components/Title/title.component";
import { ALERTAS_PERMISSIONS } from "../../../constants/index";
import AnaliseService from "../../../services/analiseService";
import { getUsername } from "../../../services/auth";
import SelectService from "../../../services/comumService";
import DownloadService from "../../../services/downloadService";
import FileHelper from "../../../utils/fileHelpers";
import { ANALISE_MODEL } from "../../../utils/models";
import ToastHelper from "../../../utils/toastHelper";

class CadastroAnalise extends Component {
	state = {
		isOpenDialog: false,
		isOpenDialogCancelar: false,
		files: [],
		isReseted: false,
		origens: [],
		origemSelecionada: null,
		isDirty: false,
		analises: ANALISE_MODEL,
		loading: false
	};

	columns = [
		{ id: 0, title: "Origem", property: "origem.nome" },
		{ id: 1, title: "Descrição", property: "descricao" },
		{ id: 2, title: "Data ", property: "dataAnalise" },
		{ id: 3, title: "Hora ", property: "horaAnalise" },
		{ id: 4, title: "Responsável", property: "responsavel" }
	];

	actions = [
		{
			id: 0,
			name: "Download da imagem",
			icon: "fas fa-download",
			action: item => this.downloadFile(item)
		}
	];

	async componentDidMount() {
		const {
			props: { alertaId },
			state: { analises }
		} = this;

		const promises = [];

		let responses = {};
		let { responseAnalise, responseOrigens } = responses;

		/* Traz os dados da etapa análise, caso existam, serve para edição */
		promises.push(
			AnaliseService.findMonitoramentoByAlertaId(alertaId).then(
				response => (responseAnalise = response)
			)
		);

		/* Selects Origem e Responsaveis */
		promises.push(
			SelectService.findAllOrigens().then(
				response => (responseOrigens = response)
			)
		);
		this.setLoading(true);
		Promise.all(promises)
			.then(() => {
				this.setState({
					analises: {
						...analises,
						registro: {
							...analises.registro,
							dataAnalise: this.getDateNow(),
							horaAnalise: this.getTimeNow()
						},
						monitoramento: {
							...responseAnalise
						}
					},
					origens: [...responseOrigens.data],
					loading: false
				});
			})
			.catch(() => {
				this.setLoading(false);
			});
	}

	setLoading(loading) {
		this.setState({ loading });
	}

	componentWillUnmount() {
		/* Submit form, sempre quando sair da tela, usado para salvar ao clicar em outra aba */
		const { analises } = this.state;
		this.handleSubmit(analises);
	}

	/*
		HANDLE CHANGE SELECTS
	*/
	onChangeSelect(item, entidadeSelecionada, entidade) {
		/* Cria um novo estado, com os campos do select, usado aqui porque os selects
		usam campos, com valoes labels e values e no nosso caso, usamos nome ao inves de label,
		e o id ao inves de value */
		const newState = this.state;
		newState[entidadeSelecionada] = item.object;
		newState.analises.registro[entidade] = item.object;
		this.setState(newState);
	}

	/*
		SUBMITA O FORMS
	*/
	handleSubmit = async () => {
		const {
			state: { analises, isDirty }
		} = this;
		if (isDirty) {
			try {
				await AnaliseService.saveAnalise(analises.monitoramento);

				ToastHelper.success("Análise salva com sucesso!");
				this.updateAfterSubmit();
			} catch (error) {
				ToastHelper.warn(error.response.data.message);
			}
		}
	};

	/*
		Atualiza o estado, após salvar
	*/
	updateAfterSubmit = async () => {
		const {
			props: { alertaId },
			state: { analises }
		} = this;
		const responseAnalise = await AnaliseService.findMonitoramentoByAlertaId(
			alertaId
		);
		this.setState({
			analises: {
				...analises,
				monitoramento: {
					...responseAnalise
				}
			}
		});
	};

	/*
		HANDLE CHANGE INPUTS NORMAIS
		Serve para lidar inputs, sem ser selects
	*/
	handleInputChange = event => {
		const { analises } = this.state;
		const { target } = event;
		const { name } = target;

		this.setState({
			analises: {
				...analises,
				registro: {
					...analises.registro,
					[name]: target.value
				}
			}
		});
	};

	/*
		MODAIS CANCELAR
		Modais ao apertar o botão cancelar
	*/
	handleCancelar = () => {
		this.setState({ isOpenDialogCancelar: true, isDirty: false });
	};

	handleDialogCancelar = isOpenDialog => (
		<WidgetDialog
			title="Atenção!"
			isOpen={isOpenDialog}
			textCancelar="Não"
			textConfirmar="Sim"
			mensagem="Tem certeza que deseja cancelar? Todos os dados preenchidos serão perdidos"
			cancelar={() => {
				this.setState({ isOpenDialogCancelar: false });
			}}
			confirmar={() => {
				this.setState({ isOpenDialogCancelar: false });
				this.props.history.push("/alertas");
			}}
		/>
	);

	/*
		ADICIONA NOVO REGISTRO
	*/
	handleAdicionarRegistro = values => {
		const { analises } = this.state;

		/* Clona os valores do formik, para não modificar o original */
		const cloneValues = {
			...values
		};

		/* Formata hora e data, para ser exibida na tabela, existe outro desse ao salvar registro */
		cloneValues.horaAnalise = moment(values.horaAnalise, "HH:mm").format(
			"HH:mm:ss"
		);
		cloneValues.dataAnalise = moment(values.dataAnalise).format(
			"DD/MM/YYYY"
		);

		cloneValues.responsavel = getUsername();

		/* Verica se a data e hora é válida */
		if (cloneValues.dataAnalise === undefined) {
			ToastHelper.warn("Data inválida, verifique o campo de data.");
			return false;
		}
		if (cloneValues.horaAnalise === "Invalid date") {
			ToastHelper.warn("Hora inválida, verifique o campo de hora.");
			return false;
		}

		/* Usado para duas coisas:
			1ª: Salva os valores dos registros, no array de registros da análise, é salvo localmente
			2ª: Reseta o forms do Registro, para resetar campos com InputText,
			deve se usar o isReseted = true
		*/
		this.setState({
			origemSelecionada: null,
			responsavelSelecionado: null,
			files: [],
			isReseted: true,
			isDirty: true,
			analises: {
				registro: {
					fileField: null,
					dataAnalise: this.getDateNow(),
					descricao: "",
					documento: "",
					horaAnalise: this.getTimeNow(),
					origem: 0,
					responsavel: ""
				},
				monitoramento: {
					...analises.monitoramento,
					registroMonitoramento: [
						...analises.monitoramento.registroMonitoramento,
						cloneValues
					]
				}
			}
		});
		this.handleReset();
	};

	handleReset = () => {
		setInterval(() => {
			this.setState({
				isReseted: false
			});
		}, 1000);
	};

	/*
		DOWNLOAD E UPLOAD
	*/
	onDrop = async (files, values) => {
		const { analises } = this.state;
		const response = await AnaliseService.uploadDocumentoRegistro(
			values,
			files
		);
		/* Registra a resposta do upload, a resposta é o registro inteiro, mais o documento.
			Serve para não perder os dados, ao fazer o upload
		*/
		this.setState({
			analises: {
				...analises,
				registro: response
			}
		});
	};

	downloadFile = async registro => {
		const { data: arquivo } = await DownloadService.download(
			registro.documento
		);
		const fileSignature = FileHelper.buf2hex(arquivo);
		const fileMimeType = FileHelper.getMimetype(fileSignature.slice(0, 8));

		const blob = new Blob([arquivo], { type: fileMimeType });
		saveAs(blob, registro.documento.nome);
	};

	/* Verifica se botão adicionar está habilitado ou não */
	validate = values => {
		if (
			values.dataAnalise === "" ||
			values.descricao === "" ||
			values.horaAnalise === undefined ||
			values.horaAnalise === "" ||
			values.origem === 0 ||
			values.documento === undefined
		) {
			return false;
		}
		return true;
	};

	getInputLength = (values, valuesMax) => {
		const caracteresRestantes = valuesMax - values.length;
		return caracteresRestantes;
	};

	getContador = values => {
		const contTotal = values.length > 0 ? values.length : "";
		return contTotal;
	};

	getDateNow = () => {
		let formataData = new Date();
		const dia = String(formataData.getDate()).padStart(2, "0");
		const mes = String(formataData.getMonth() + 1).padStart(2, "0");
		const ano = formataData.getFullYear();

		formataData = `${ano}-${mes}-${dia}`;

		return formataData;
	};

	getTimeNow = () => {
		let formatTime = new Date();

		const hora = String(formatTime.getHours()).padStart(2, "0");
		const minuto = String(formatTime.getMinutes()).padStart(2, "0");

		formatTime = `${hora}:${minuto}`;

		return formatTime;
	};

	getFormatedData = registros => {
		const formatedRegistros = [];

		registros.forEach(element => {
			const registro = {};
			registro.horaAnalise = (element.horaAnalise || "").substring(5, 0);
			registro.dataAnalise = element.dataAnalise;
			registro.descricao = element.descricao;
			registro.documento = element.documento;
			registro.id = element.id;
			registro.origem = element.origem;
			registro.responsavel = element.responsavel;

			formatedRegistros.push(registro);
		});
		return formatedRegistros;
	};

	getDataMax = () => {
		const dataAtual = new Date();
		let dia = dataAtual.getDate();
		let mes = dataAtual.getMonth() + 1;
		const ano = dataAtual.getFullYear();

		if (mes <= 9) {
			mes = `0${mes}`;
		}
		if (dia <= 9) {
			dia = `0${dia}`;
		}

		return `${ano}-${mes}-${dia}`;
	};

	/* Ordena as origens pelo ID */
	orderOrigens(origens) {
		origens.sort(compareByNome);
		return origens;
	}

	checkDataValue = data => {
		const dataMax = this.getDataMax();
		if (data > dataMax) {
			return dataMax;
		}
		return data;
	};

	render() {
		const {
			props: { onClick },
			state: {
				isOpenDialogCancelar,
				isReseted,
				origens,
				origemSelecionada,
				analises: { registro, monitoramento }
			}
		} = this;
		return (
			<div>
				<div className="container content-container">
					{this.state.loading && (
						<LoadingStyle className="loading">
							<div className="text-center">
								<div className="spinner-border" role="status" />
							</div>
						</LoadingStyle>
					)}
					<Title>Análise</Title>
					<hr />

					<Accordion className="mb-0">
						<AccordionItem title="Links úteis" titleTag="h5">
							<table className="table table-sm mb-0">
								<tbody>
									{LISTA_LINKS_AUDIENCIA.map(site => (
										<tr
											className="first-item"
											key={site.key}
										>
											<th scope="row" />
											<td>{site.nome}</td>
											<td>
												<a
													target="_blank"
													rel="noopener noreferrer"
													href={site.link}
												>
													{site.link}
												</a>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</AccordionItem>
					</Accordion>

					<Formik
						initialValues={registro}
						enableReinitialize
						onSubmit={this.handleSubmit}
					>
						{({ values, setFieldValue }) => (
							<Form>
								<div>
									<Subtitle>Registro de análises</Subtitle>
									<hr />
									<div className="row">
										<div className="col-md-6">
											<label>
												Origem: <Required />
											</label>
											<div className="form-group">
												<SelectMulti
													isClearable={false}
													isMulti={false}
													name="origem"
													label="nome"
													className="form-control form-control-sm"
													value={
														origemSelecionada ||
														values.origem ||
														""
													}
													onChange={item => {
														this.onChangeSelect(
															item,
															"origemSelecionada",
															"origem"
														);
													}}
													options={this.orderOrigens(
														origens
													)}
												/>
											</div>
										</div>

										<div className="col-lg-3">
											<label>
												Data: <Required />
											</label>
											<InputText
												reset={isReseted || undefined}
												max={this.getDataMax()}
												checkDate={this.checkDataValue}
												type="date"
												name="dataAnalise"
												onChange={
													this.handleInputChange
												}
												value={values.dataAnalise || ""}
											/>
										</div>

										<div className="col-lg-3">
											<label>
												Hora: <Required />
											</label>
											<div className="form-group">
												<InputText
													reset={
														isReseted.toString() ||
														undefined
													}
													type="time"
													name="horaAnalise"
													onChange={
														this.handleInputChange
													}
													value={
														values.horaAnalise || ""
													}
												/>
											</div>
										</div>
									</div>

									<div className="row">
										<div className="col-md-6">
											<label>
												Descrição: <Required />
											</label>
											<div className="form-group">
												<InputText
													reset={
														isReseted.toString() ||
														undefined
													}
													type="textarea"
													name="descricao"
													maxLength="255"
													onChange={
														this.handleInputChange
													}
													value={
														values.descricao || ""
													}
												/>
												<p className="text-right mb-0">
													{this.getInputLength(
														values.descricao,
														255
													)}{" "}
													<span>
														caracteres restantes
													</span>
												</p>
											</div>
										</div>
										<div className="col-md-6">
											<label>
												Anexar imagem: <Required />
											</label>
											<div className="form-group">
												<UploadBrowseFile
													context={this}
													acceptedFileTypes={[
														"image/png",
														"image/jpeg",
														"image/jpg",
														"image/bmp",
														"image/tiff"
													]}
													onUpload={this.onDrop}
													valuesFormik={values}
													aspectRatio={0.1}
													expetedTypesLabel="Selecione arquivos de imagens"
													label="Arraste e solte ou <strong>clique</strong> para selecionar uma imagem"
													handleRemoveFile={() => {
														this.setState({
															files: [],
															analises: {
																...this.state
																	.analises,
																registro: {
																	...registro,
																	documento: undefined
																}
															}
														});
													}}
												/>
											</div>
										</div>
									</div>

									<div className="row mt-2">
										<div className="col-md-12">
											<div className="float-right ">
												<Button
													disabled={
														!this.validate(values)
													}
													type="button"
													primary
													text="Adicionar"
													icon="fas fa-plus"
													onClick={() =>
														this.handleAdicionarRegistro(
															values
														)
													}
												/>
											</div>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<Subtitle>Registros</Subtitle>
										</div>
									</div>
									<hr />
									<Table
										acoesSingleButton
										columns={this.columns}
										actions={this.actions}
										data={this.getFormatedData(
											monitoramento.registroMonitoramento
										)}
										emptyMessage="Não há registros cadastrados."
										emptyColSpan={this.columns.length + 1}
										permission={
											ALERTAS_PERMISSIONS.VISUALIZAR
										}
									/>

									<div className="row mt-4">
										<div className="col-6">
											<div className="row">
												<div className="col-md-12">
													<div className="float-left ">
														<Button
															onClick={() =>
																onClick("geo")
															}
															type="button"
															primary
															text="Voltar"
															icon="fas fa-arrow-left"
														/>
														<Button
															type="button"
															cancel
															text="Cancelar"
															icon="fas fa-times"
															onClick={() =>
																this.handleCancelar()
															}
														/>
													</div>
												</div>
											</div>
										</div>

										<div className="col-6">
											<div className="row">
												<div className="col-md-12">
													<div className="float-right">
														<Button
															type="submit"
															primary
															text="Salvar"
															icon="fas fa-save"
														/>

														<Button
															onClick={() =>
																onClick(
																	"audiencia"
																)
															}
															type="submit"
															primary
															text="Próximo"
															icon="fas fa-arrow-right"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</Form>
						)}
					</Formik>
				</div>
				{this.handleDialogCancelar(isOpenDialogCancelar)}
			</div>
		);
	}
}

export default withRouter(CadastroAnalise);
